// extracted by mini-css-extract-plugin
module.exports = {"footer":"VUGIP","titleWrapper":"DKc7K","trademark":"_3_slm","title":"zi7w0","socials":"zkgeN","social":"_3VAjb","socialIconWrapper":"_2M7xG","socialIcon":"_2rBQp"};